function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.472 3.753C1.472 2.533 2.555 1.46 4 1.46s2.528 1.072 2.528 2.292v.778A6.001 6.001 0 1015 10a6 6 0 00-7-5.917v-.33C8 1.633 6.16 0 4 0S0 1.634 0 3.753V5.27c0 .403.33.73.736.73a.733.733 0 00.736-.73V3.753zM8 9a1 1 0 112 0v2a1 1 0 11-2 0V9z",
  fill: "currentColor"
})));